export const getMouseWithScale = (xScale, yScale, yScale2, mouse) => {
    if (mouse) {
        const y2 = yScale2 ? yScale2.invert(mouse[1] ? mouse[1] : null) : null;
        return {
            x: xScale.invert(mouse[0] ? mouse[0] : null),
            y: yScale.invert(mouse[1] ? mouse[1] : null),
            y2,
        };
    }
    return undefined;
};
//# sourceMappingURL=utils.js.map